module.exports = __webpack_public_path__ + "static/img/item5.50706a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wap/item5.png
// module id = 9t5g
// module chunks = 0